import classNames from 'classnames';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMatriculados,
  setPage,
  setPropsLimit
} from 'redux/matriculadosSlice';
import AdvanceTable from '../../../inmobiliario/gestionarUsuarios/tables/usersTable/AdvanceTable';
import AdvanceTableWrapper from '../../../inmobiliario/gestionarUsuarios/tables/usersTable/AdvanceTableWrapper';

const MatriculadosTableWrapper = ({ columns, data }) => {
  const dispatch = useDispatch();
  const page = useSelector(state => state.matriculados.page);
  const propsLimit = useSelector(state => state.matriculados.propsLimit);
  const matriculadosTotal = useSelector(
    state => state.matriculados.matriculadosTotal
  );
  const searchProp = useSelector(state => state.matriculados.searchProp);
  const filtersAndSort = useSelector(
    state => state.matriculados.filtersAndSort
  );

  const canNextPage = Math.ceil(matriculadosTotal / propsLimit) > page + 1;
  const canPreviousPage = page > 0;

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(getMatriculados(filtersAndSort, page, propsLimit, searchProp));
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [page, filtersAndSort, searchProp, propsLimit]);

  useEffect(() => {
    dispatch(setPage(0));
  }, [filtersAndSort, searchProp, propsLimit]);

  const nextPage = () => {
    dispatch(setPage(page + 1));
  };

  const previousPage = () => {
    dispatch(setPage(page - 1));
  };
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={15}
    >
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle text-black"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden border-light'
        }}
      />

      <div
        className="mt-3"
        style={{
          overflowX: 'auto',
          padding: '20px 0 20px 0'
        }}
      >
        <Flex className={'align-items-center justify-content-between'}>
          <Flex alignItems="center" className="fs--1">
            <p className="mb-0">
              {matriculadosTotal > 0 ? (
                <span className="d-none d-sm-inline-block me-2">
                  Viendo del {page === 0 ? 1 : propsLimit * page + 1} al{' '}
                  {Math.min(propsLimit * (page + 1), matriculadosTotal)} de{' '}
                  {matriculadosTotal} total
                </span>
              ) : (
                <span className="d-none d-sm-inline-block me-2">
                  No hay resultados
                </span>
              )}
            </p>

            <p className="mb-0 mx-2">Fila por página:</p>
            <Form.Select
              size="sm"
              className="w-auto"
              onChange={e => dispatch(setPropsLimit(e.target.value))}
              defaultValue={propsLimit}
            >
              {[5, 10, 15].map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </Flex>
          <Flex>
            <Button
              size="sm"
              variant={canPreviousPage ? 'primary' : 'light'}
              onClick={() => previousPage()}
              className={classNames({ disabled: !canPreviousPage })}
            >
              Anterior
            </Button>
            <Button
              size="sm"
              variant={canNextPage ? 'primary' : 'light'}
              className={classNames('px-4 ms-2', {
                disabled: !canNextPage
              })}
              onClick={() => nextPage()}
            >
              Siguiente
            </Button>
          </Flex>
        </Flex>
      </div>
    </AdvanceTableWrapper>
  );
};

MatriculadosTableWrapper.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired
  // rowCount: PropTypes.number.isRequired
};

export default MatriculadosTableWrapper;
